<div class="news-card" [ngClass]="{ full: isFull }">
  <div class="news-card__body">
    <div class="mb-2 flex gap-2 align-middle">
      <div
        class="news-card__label"
        [ngClass]="{ 'bug-fix': news.type === bugFixType }"
      >
        {{ news.type }}
      </div>
      <div class="news-card__date">
        {{ news.createdAt | date: 'MMMM dd, yyyy' }}
      </div>
    </div>
    <div class="news-card__title">{{ news.title }}</div>
    <p class="news-card__content">
      {{
        news.description | slice: 0 : (isFull ? news.description.length : 122)
      }}
      {{ news.description.length > 122 && !isFull ? '...' : '' }}
      <cpd-link-button
        *ngIf="news.description.length > 122 && !isFull"
        (click)="viewMore()"
        color="secondary"
        fontIcon="chevron-right"
        fontSet="fas"
      >
      </cpd-link-button>
    </p>
  </div>
  <div class="news-card__actions">
    <div class="news-card__question">Do you like this feature?</div>
    <div class="news-card__like">
      <div class="w-50">
        <button
          type="button"
          class="link-button reaction-button"
          aria-label="Yes, I like this feature"
          [attr.aria-pressed]="news?.reaction === reactionEnumNumber.Like"
          (click)="reactOnNews(reactionEnum.Like)"
        >
          <mat-icon
            *ngIf="news?.reaction === reactionEnumNumber.Like"
            class="fill"
            svgIcon="thumbs-up-fill"
          ></mat-icon>
          <mat-icon
            *ngIf="news?.reaction === reactionEnumNumber.Dislike"
            class="fill-gray"
            svgIcon="thumbs-up-fill"
          ></mat-icon>
          <mat-icon *ngIf="!news?.reaction" svgIcon="thumbs-up"></mat-icon>
        </button>
      </div>
      <div class="w-50">
        <button
          type="button"
          class="link-button reaction-button"
          aria-label="No, I do not like this feature"
          [attr.aria-pressed]="news?.reaction === reactionEnumNumber.Dislike"
          (click)="reactOnNews(reactionEnum.Dislike)"
        >
          <mat-icon
            *ngIf="news?.reaction === reactionEnumNumber.Dislike"
            class="fill"
            svgIcon="thumbs-down-fill"
          ></mat-icon>
          <mat-icon
            *ngIf="news?.reaction === reactionEnumNumber.Like"
            class="fill-gray"
            svgIcon="thumbs-down-fill"
          ></mat-icon>
          <mat-icon *ngIf="!news?.reaction" svgIcon="thumbs-down"></mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
